interface IImageModal {
  icon: string;
  text: string;
}

export function FeatureIcon({ icon, text }: IImageModal) {
  return (
    <div
      style={{
        display: 'flex',
      }}
    >
      <b
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <i
          className="material-icons-outlined"
          style={{
            display: 'flex',
            alignItems: 'center',
            marginRight: '5px',
          }}
        >
          {icon}
        </i>
        {text}
      </b>
    </div>
  );
}
